<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <h1>New Media Post</h1>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="newItem.title" label="Title"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="newItem.subtitle" label="Subtitle"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="newItem.url" label="Link to media"></v-text-field>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <v-switch v-model="newItem.html" label="Description"></v-switch>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <v-switch v-model="newItem.paper_html" label="Footer"></v-switch>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <v-switch :disabled="newItem.video" v-model="newItem.image" label="Image"></v-switch>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <v-switch :disabled="newItem.image" v-model="newItem.video" label="Video"></v-switch>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <v-switch
          :disabled="!newItem.video||newItem.image"
          v-model="newItem.youtube"
          label="Youtube"
        ></v-switch>
      </v-col>
      <v-col v-if="newItem.html" cols="12">
        <v-textarea v-model="newItem.html_text" auto-grow rows="1" label="Description (html)"></v-textarea>
      </v-col>
      <v-col v-if="newItem.paper_html" cols="12">
        <v-textarea v-model="newItem.paper_html_text" auto-grow rows="1" label="Footer (html)"></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-textarea v-model.number="newItem.order" auto-grow rows="1" label="Post count"></v-textarea>
      </v-col>
      <v-col v-if="newItem.image || (newItem.video&&!newItem.youtube)" cols="12">
        <v-file-input v-model="newItem.mediaUrl" label="Media"></v-file-input>
      </v-col>
      <v-col v-if="newItem.youtube" cols="12">
        <v-text-field v-model="newItem.mediaUrl" label="Link to Youtube video"></v-text-field>
      </v-col>
      <v-col class="button" cols="4">
        <v-btn :loading="loading" class="button" color="white" elevation="1" @click="create">Create</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h1>Edit Media Post</h1>
      </v-col>
      <v-col class="d-flex" cols="12">
        <v-select
          v-model="id"
          :items="media"
          item-text="title"
          item-value="id"
          label="Media to edit"
          filled
          v-on:change="updateItem"
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="id">
      <v-col cols="12">
        <v-text-field v-model="item.title" label="Title"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="item.subtitle" label="Subtitle"></v-text-field>
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="item.url" label="Link to media post"></v-text-field>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <v-switch v-model="item.html" label="Description"></v-switch>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <v-switch v-model="item.paper_html" label="Footer"></v-switch>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <v-switch v-model="item.image" label="Image"></v-switch>
      </v-col>
      <v-col cols="6" sm="4" md="3" lg="2">
        <v-switch v-model="item.video" label="Video"></v-switch>
      </v-col>
      <v-col v-if="item.html" cols="12">
        <v-textarea v-model="item.html_text" auto-grow rows="1" label="Description (html)"></v-textarea>
      </v-col>
      <v-col v-if="item.paper_html" cols="12">
        <v-textarea v-model="item.paper_html_text" auto-grow rows="1" label="Footer (html)"></v-textarea>
      </v-col>
      <v-col cols="12">
        <v-textarea v-model.number="item.order" auto-grow rows="1" label="Post count"></v-textarea>
      </v-col>
      <v-col v-if="item.youtube" cols="12">
        <v-text-field v-model="item.mediaUrl" label="Youtube video link: "></v-text-field>
      </v-col>
      <v-col v-if="item.image" cols="12" md="6">
        <v-img class="image" contain :src="item.mediaUrl"></v-img>
      </v-col>
      <v-col v-if="item.image ||item.video" cols="12" md="4">
        <v-file-input v-model="newFile" label="New media" ></v-file-input>
      </v-col>
      <v-col cols="6" md='4'>
        <v-btn :loading="loading" color="white" elevation="1" @click="update">Update</v-btn>
      </v-col>

      <v-col cols="6" md='4'>
        <v-btn :loading="loading" color="red" elevation="1" @click="delet">Delete</v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { uploadPhoto } from "@/helpers/storage.js";

export default {
  name: "MediaEdit",
  data() {
    return {
      id: null,
      item: {},
      loading: false,
      newFile: null,
      newItem: {
        html: false,
        html_text: "",
        image: false,
        mediaUrl: null,
        order: null,
        paper_html: false,
        paper_html_text: "",
        subtitle: "",
        title: "",
        url: "",
        video: false,
        youtube: false
      }
    };
  },
  computed: mapState(["loadingMedia", "media"]),
  mounted() {
    if (!this.media.length) {
      this.$store.dispatch("cargarMedia");
    }
  },

  methods: {
    updateItem() {
      this.item = this.media.find(val => val.id === this.id);
    },
    update() {
      this.loading = true;
      if(this.newFile!=null){
        this.newFileMet();
      }
      if (this.id)
        this.$store
          .dispatch("updateMedia", this.item)
          .then(() => ((this.loading = false), alert("Updated!")))
          .catch(() => alert("Error! Try again later"));
      
    },
    create() {
      this.loading = true;
      if (
        (this.newItem.image || this.newItem.video) &&
        (this.newItem.mediaUrl != null) && (typeof this.newItem.mediaUrl === 'object')
      ) {
        //console.log(this.newItem)
        let updatedItem = {};
        Object.assign(updatedItem, this.newItem);
        delete updatedItem.mediaUrl;
        this.$store.dispatch("addMedia", updatedItem).then(id => {
          if(this.newItem.mediaUrl!=null){
            uploadPhoto("media", id, this.newItem.mediaUrl).then(link => {
              updatedItem.mediaUrl = link;
              updatedItem.id = id;
              this.$store.dispatch("updateMedia", updatedItem).then(() => {
                this.loading = false;
                alert("Content created!");
              });
            });
          }
        });
      } else {
        //console.log('youtube')
        this.$store
          .dispatch("addMedia", this.newItem)
          .then(() => (this.loading = false), alert("New Content Uploaded"));
      }
    },
    delet() {
      this.loading = true;
      if (this.id)
        this.$store
          .dispatch("deleteMedia", this.item)
          .then(() => (this.loading = false));
      this.item = {};
    },
    newFileMet() {
      uploadPhoto("media", this.item.id, this.newFile).then(link => {
        this.item.mediaUrl = link;
        this.$store
          .dispatch("updateMedia", this.item)
          .then(() => alert("Photo updated!"));
      });
    }
  }
};
</script>

<style scoped>
.button {
  align-self: flex-start;
  margin: auto;
}
</style>